import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Panel, Overline, ProgressBar, ProgressRing, Icon, PageLoader, EmptyState, gradFor } from "../../components/ui-kit";

export default function LearnHub() {
  const [subjects, setSubjects] = useState(null);
  useEffect(() => { api.get("/academics/subjects").then(({ data }) => setSubjects(data)); }, []);
  if (!subjects) return <PageLoader />;

  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-6">
      <div className="mb-7 pt-1">
        <Overline>Learning Hub</Overline>
        <h1 className="text-3xl sm:text-4xl font-bold text-mim-navy mt-1 tracking-tight">Choose a subject</h1>
        <p className="text-mim-muted mt-1">Explore chapters and topics through interactive lessons.</p>
      </div>
      {subjects.length === 0 ? (
        <Panel tint="soft"><EmptyState icon="BookOpen" title="No subjects assigned yet" subtitle="Your school will add subjects soon." /></Panel>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 stagger">
          {subjects.map((s) => (
            <Link key={s.id} to={`/learn/subject/${s.id}`}>
              <div className="relative rounded-[28px] p-6 text-white overflow-hidden hover-lift h-full" style={{ background: gradFor(s.color) }}>
                <div className="absolute inset-0 dotgrid opacity-40 pointer-events-none" />
                <div className="relative z-10">
                  <div className="flex items-start justify-between">
                    <div className="w-12 h-12 rounded-2xl glass flex items-center justify-center"><Icon name={s.icon} className="w-6 h-6" /></div>
                    <ProgressRing value={s.progress || 0} size={58} stroke={6} color="#ffffff" track="rgba(255,255,255,0.22)" label={`${s.progress || 0}%`} labelClass="text-white" />
                  </div>
                  <h3 className="text-2xl font-bold mt-5">{s.name}</h3>
                  <p className="text-sm text-white/75 mt-0.5">{s.chapter_count} chapters · {s.total_topics || 0} topics</p>
                  <div className="flex items-center justify-between text-xs text-white/80 mt-4 mb-1.5"><span>Mastery</span><span className="font-semibold">{s.mastery || 0}%</span></div>
                  <ProgressBar value={s.mastery || 0} color="#ffffff" track="rgba(255,255,255,0.22)" height="h-2" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
